/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import './home.scss';

import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Alert, Col, Row } from 'reactstrap';

import { REDIRECT_URL, getLoginUrl } from 'app/shared/util/url-utils';
import { useAppSelector } from 'app/config/store';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);
  const pageLocation = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectURL = localStorage.getItem(REDIRECT_URL);
    if (redirectURL) {
      localStorage.removeItem(REDIRECT_URL);
      location.href = `${location.origin}${redirectURL}`;
    }
  });

  return (
    <Row>
      <Col md="3" className="pad">
        <span className="hipster rounded" />
      </Col>
      <Col md="9">
        <h1 className="display-4">
          <Translate contentKey="home.title">Welcome, TinyMedic API Gateway!</Translate>
        </h1>
        <p className="lead">
          <Translate contentKey="home.subtitle">The Revolution in Health Care</Translate>
        </p>
        {account?.login ? (
          <div>
            <Alert color="success">
              <Translate contentKey="home.logged.message" interpolate={{ username: account.login }}>
                You are logged in as user {account.login}.
              </Translate>
            </Alert>
          </div>
        ) : (
          <div>
            <Alert color="warning">
              <Translate contentKey="global.messages.info.authenticated.prefix">Click if you want to </Translate>

              <a
                className="alert-link"
                onClick={() =>
                  navigate(getLoginUrl(), {
                    state: { from: pageLocation },
                  })
                }
              >
                <Translate contentKey="global.messages.info.authenticated.link">sign in</Translate>
              </a>
              {/* <Translate contentKey="global.messages.info.authenticated.suffix">
                , you can try the default accounts:
                <br />- Administrator (login=&quot;admin&quot; and password=&quot;admin&quot;)
                <br />- User (login=&quot;user&quot; and password=&quot;user&quot;).
              </Translate>  */}
            </Alert>
          </div>
        )}
        <p>
          <Translate contentKey="home.question">If you have any question, Reach us :</Translate>
        </p>

        <ul>
          <li>
            <a href="https://www.tinymedic.com/" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.homepage">www.tinymedic.com</Translate>
            </a>
          </li>
          <li>
            <a href="http://www.tinymedic.com/privacyplicy" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.stackoverflow">Privacy Policy</Translate>
            </a>
          </li>
          <li>
            <a href="https://tinymedic.jira.com" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.bugtracker">Report an issue</Translate>
            </a>
          </li>
          <li>
            <a href="https://gitter.im/tinymedic/tinymedic_india" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.chat">Public chat room</Translate>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/tinyMedic" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.follow">follow @tinyMedic on Twitter</Translate>
            </a>
          </li>
        </ul>

        <p>
          <Translate contentKey="home.like">If you like TinyMedic, do not forget to share with your friends & family</Translate>{' '}
          <a href="https://twitter.com/tinyMedic" target="_blank" rel="noopener noreferrer">
            ...
          </a>
          !
        </p>
      </Col>
    </Row>
  );
};

export default Home;
